import { RemixBrowser } from "@remix-run/react";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

startTransition(() => {
  const root = document.querySelector("#app");
  if (!root) throw new Error("Root element not found");
  
  hydrateRoot(
    root,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});
